import React from 'react';
import { Box } from '@mui/material';
import { node } from 'prop-types';

const SelectTitle = ({ headline }) => (
  <Box
    sx={{
      height: '22px',
      mt: '5px',
      mb: '5px',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSize: '15px',
      fontWeight: 600,
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 1.47,
      letterSpacing: '-0.4px',
      color: 'text.primary',
    }}
  >
    {headline}
  </Box>
);

SelectTitle.propTypes = {
  headline: node.isRequired,
};

export default SelectTitle;
